// Module
var code = "<accounting-codes-settings on-success=\"onSuccess\" on-error=\"onError\"> </accounting-codes-settings> ";
// Exports
var _module_exports = code;;
var path = '/admin/invoices/codes.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;